import React, { useEffect, useState } from "react";
import { useCore } from "store/core";
import SelectReact from "react-select";

const Multiselect = (props) => {
  const { form, field } = props;
  const { list } = useCore();
  const [selectedItems, setSelected] = useState([]);
  const catalogAppearance = props.appearance === "catalog";
  const isDark = document.documentElement.classList.contains("dark");

  useEffect(() => {
    if (field.value) {
      if (props.valueOnly) {
        setSelected(
          props.options.filter((item) => field.value.includes(item.value))
        );
      } else {
        setSelected(list(field.value));

        form.setFieldValue(
          field.name,
          field.value.map((item) => item.id)
        );
      }
    }
  }, [props.options]);

  const onChangeHandler = (items) => {
    setSelected(items);

    form.setFieldValue(
      field.name,
      items.map((item) => item.value)
    );
  };

  const defaultStyles = {
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
      backgroundColor: "#313a55",
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: "#313a55",
    }),
    option: (base, { isSelected }) => ({
      ...base,
      backgroundColor: isSelected ? "#404a66" : "#313a55",
      color: "#ffffff",
      "&:hover": {
        backgroundColor: "#404a66",
      },
    }),
    control: (base) => ({
      ...base,
      backgroundColor: "#313a55",
      color: "#ffffff",
    }),
    singleValue: (base) => ({ ...base, color: "#ffffff" }),
    input: (base) => ({ ...base, color: "#ffffff" }),
    placeholder: (base) => ({ ...base, color: "#a0aec0" }),
  };

  const catalogStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 10000 }),
    menu: (base) => ({
      ...base,
      overflow: "hidden",
      border: `1px solid ${isDark ? "#4b5878" : "#d7deea"}`,
      backgroundColor: isDark ? "#293145" : "#ffffff",
      boxShadow: "0 14px 30px rgba(15, 23, 42, 0.22)",
    }),
    menuList: (base) => ({ ...base, padding: 6 }),
    option: (base, { isFocused, isSelected }) => ({
      ...base,
      marginBottom: 2,
      borderRadius: 6,
      backgroundColor: isSelected
        ? "#3654c7"
        : isFocused
        ? isDark
          ? "#3b4661"
          : "#eef2ff"
        : "transparent",
      color: isSelected ? "#ffffff" : isDark ? "#e5e7eb" : "#334155",
      cursor: "pointer",
      textAlign: "right",
    }),
    control: (base, state) => ({
      ...base,
      minHeight: 44,
      borderRadius: 6,
      borderColor: state.isFocused ? "#4f6fe8" : isDark ? "#4b5878" : "#d7deea",
      backgroundColor: isDark ? "#293145" : "#ffffff",
      boxShadow: state.isFocused
        ? "0 0 0 3px rgba(79, 111, 232, 0.16)"
        : "none",
      cursor: "text",
      "&:hover": { borderColor: "#6b82dd" },
    }),
    valueContainer: (base) => ({ ...base, padding: "4px 10px" }),
    multiValue: (base) => ({
      ...base,
      borderRadius: 5,
      backgroundColor: isDark ? "#414d6a" : "#e9edff",
    }),
    multiValueLabel: (base) => ({
      ...base,
      padding: "5px 7px",
      color: isDark ? "#f3f4f6" : "#283a89",
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: isDark ? "#cbd5e1" : "#5162a4",
      "&:hover": { backgroundColor: "#e05268", color: "#ffffff" },
    }),
    input: (base) => ({ ...base, color: isDark ? "#ffffff" : "#334155" }),
    placeholder: (base) => ({ ...base, color: isDark ? "#9eabc4" : "#94a3b8" }),
    dropdownIndicator: (base) => ({
      ...base,
      color: isDark ? "#aeb9ce" : "#64748b",
    }),
    clearIndicator: (base) => ({
      ...base,
      color: isDark ? "#aeb9ce" : "#64748b",
    }),
    indicatorSeparator: (base) => ({
      ...base,
      backgroundColor: isDark ? "#53607d" : "#d7deea",
    }),
  };

  return (
    <div
      className={`text-xs ${props.wrapperClassName || "col-span-2"}`}
      style={{ zIndex: 20 }}
    >
      <label
        className={
          props.labelClassName ||
          "block text-xs font-medium mb-2 text-gray-700 dark:text-gray-300"
        }
        htmlFor={field.name}
      >
        {props.label}
      </label>
      <SelectReact
        placeholder="انتخاب..."
        value={selectedItems}
        onChange={onChangeHandler}
        options={props.options}
        menuPortalTarget={document.body}
        styles={catalogAppearance ? catalogStyles : defaultStyles}
        isRtl={catalogAppearance}
        closeMenuOnSelect={!catalogAppearance}
        noOptionsMessage={() => "گزینه‌ای یافت نشد"}
        isClearable={true}
        isMulti
        className={catalogAppearance ? "catalog-multi-select" : "bg-[#313a55]"}
      />
      <span className="text-xs text-red-400">{form.errors[field.name]}</span>
    </div>
  );
};

export default Multiselect;
